import * as React from "react";
import type { SVGProps } from "react";
const SvgLightningLesson = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={66}
    fill="none"
    {...props}
  >
    <path
      fill="#D3ECF8"
      stroke="#26A3DD"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M22.345 28.03 29.745 1 2.955 38.21h11.52L8.285 65l24.97-36.97h-10.91Z"
    />
    <path
      stroke="#26A3DD"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M30.855 19.5h30.19M39.544 27.92h21.5M34.785 36.34h26.26"
    />
  </svg>
);
export default SvgLightningLesson;
